import styled from '@emotion/styled';
import { fraudAndComplianceColors, mainColors } from 'src/assets/colors';
import {
    ColumnHeaderTemplate,
    SectionMessageTemplate,
    TableCellTemplate,
    TableHeaderRowTemplate,
    TablePropsType,
    TableRowTemplate,
    TableWrapperTemplate,
} from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';

export const GamstopTabContainer = styled('div', { label: 'GamstopTabContainer' })`
    flex: 1 1 0%;
    height: calc(100vh - 56px);
    overflow-y: auto;
    padding: 24px;
    font-size: 14px;
    line-height: 1.3;
    position: relative;
`;

export const PageHeader = styled('div', { label: 'PageHeader' })`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`;

export const Header = styled('h1', { label: 'Header' })`
    font-size: 24px;
    margin: 0;
`;

export const ErrorMessage = styled('div', { label: 'ErrorMessage' })`
    font-size: 14px;
    padding: 6px;
    margin-bottom: 16px;
    background-color: ${mainColors.status.ended};
    color: ${mainColors.status.error};
    border-radius: 4px;
`;

export const SectionWrapper = styled('div', { label: 'SectionWrapper' })``;

export const SectionHeader = styled('h2', { label: 'SectionHeader' })`
    font-size: 16px;
    color: ${fraudAndComplianceColors.withdrawalReqColors.txtColor};
    margin: 0 0 12px;
`;

export const SectionMessage = styled(SectionMessageTemplate, { label: 'SectionMessage' })`
    margin-top: 16px;
`;

export const TableWrapper = styled(TableWrapperTemplate, { label: 'TableWrapper' })``;

export const TableHeaderRow = styled(TableHeaderRowTemplate, { label: 'TableHeaderRow' })``;

export const TableRow = styled(TableRowTemplate, { label: 'TableRow' })<TablePropsType>`
    min-height: 50px;
`;

export const ColumnHeader = styled(ColumnHeaderTemplate, { label: 'ColumnHeader' })``;

export const TableCell = styled(TableCellTemplate, { label: 'TableCell' })`
    padding: 10px 8px;
`;
